export enum ExternalScriptState {
  NOT_INIT,
  READY,
  INITIALIZED,
  ERROR,
}

export enum CardWidgetField {
  CVC = 'fields-cvc',
  EXPIRATION = 'fields-expiration',
  CARD_NUMBER = 'fields-card-number',
  HOLDER_NAME = 'fields-holder-name',
}

export enum CardEventType {
  BLUR = 'blur',
  VALIDATED = 'validated',
}

export enum CardWidgetFieldsValidatorResult {
  NOT_READY,
  SHOW_LOADER,
  SHOW_PAYMENT_BUTTON,
}

export interface IState {
  externalScriptState: ExternalScriptState;
}

export interface SavedInstrumentsProps {
  hasSavedInstruments: boolean;
  handleShowSavedInstrumentClick: () => void;
}

export interface ICardEvent {
  id: string;
  event: CardEventType;
  isValid: boolean;
  fieldType: string;
  reason?: string;
}

export interface ICardTrackEvent extends ICardEvent {
  timestamp: number;
}

export class CardFieldEvent {
  event: string;

  id: string;

  fieldType: string;

  isValid: boolean;

  reason?: string;

  modifiedAt: Date;

  constructor(cardEvent: ICardEvent) {
    this.event = cardEvent.event;
    this.id = cardEvent.id;
    this.fieldType = cardEvent.fieldType;
    this.isValid = cardEvent.isValid;
    this.reason = cardEvent.reason;
    this.modifiedAt = new Date();
  }
}
